export default "__VITE_ASSET__BlSaWZez__"